module.exports = __webpack_public_path__ + "img/text-only.6254c951.svg";